module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./UploadPicsView.js"));
	}, "WithDrawApplyUploadView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WithDrawApplyUploadView!./src/pages/Shop/Member/Wallet/WithDraw/WithDrawApply/UploadPics/UploadPicsView.js
// module id = 1586
// module chunks = 418